<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaDatos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Medio de Com.</th>
          <th scope="col">Mensaje</th>
          <th scope="col">Tipo</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="bitacora in datosPaginados" :key="bitacora.idBitacora">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(bitacora.idBitacora)" title="Editar">edit_square</i></td>
          <td>{{bitacora.medioComNombre}}</td>
          <td>{{bitacora.texto}}</td>
          <td>{{bitacora.tipo}}</td>
<!--
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteBitacora(bitacora.idBitacora)" title="Borrar">delete</i></td>
-->
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaDatos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idBitacora" class="form-label">IdBitacora</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="idBitacora" name="idBitacora" v-model="datoBitacora.idBitacora" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Medio Com -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idMedioCom" class="form-label"> Medio Com</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoBitacora.idMedioCom">
                      <option v-for="medioCom in medioComs" :value="medioCom.idMedioCom" :key="medioCom.idMedioCom">
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Medio Com -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="texto" class="form-label">Texto</label>
                </div>
                <div class="col-10">
                  <textarea class="form-control" id="texto" name="texto" v-model="datoBitacora.texto" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarBitacora" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditBitacora" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idPersona: {
      type: String,
      required: true
    }
  },
  components : {
  },
  data () {
    return {
      bitacoras : [],
      datoBitacora : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
//      personas: [],
      medioComs: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
//    this.fetchPersonas()
    this.fetchMedioComs()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.bitacoras.length / this.elementosPorPagina)
    },
/*     getDataPaginaDatos(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwbitacoras/nombre/'+this.nombreBusqueda).then(response=>{
          this.bitacoras=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.bitacoras.slice(ini,fin);
        });
      }
    },
 */    getDataPaginaTodos(noPagina){
      api.get('/vwbitacoras/idpersona/'+this.p_idPersona).then(response=>{
      this.bitacoras=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.bitacoras.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaDatos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaDatos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idPersona'
        ,'idMedioCom'
        ,'texto'
      ];
      const requiredFieldsText = [
        'idPersona'
        ,'idMedioCom'
        ,'texto'
      ];
      return validarForm(this.datoBitacora, requiredFields, requiredFieldsText);
    },
    async guardarBitacora(){
      if(this.validarForm() === 1){
        try {
          await api.post('/bitacoras', this.datoBitacora)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Bitacora creada exitosamente!", "success");
          this.getDataPaginaDatos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditBitacora(){
      if(this.validarForm() === 1){
        try {
          await api.post('/bitacoras', this.datoBitacora)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaDatos(this.paginaActual);
          swal("Correcto!", "Bitacora creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoBitacora={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idBitacora){
      this.modalWindow = true
      if(idBitacora != null){    
           api.get('/vwbitacoras/'+idBitacora).then(resp=>{
          this.datoBitacora = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idBitacora){
      if(idBitacora != null){
        this.$router.push('/bitacoramd/'+idBitacora)
      }
    },
/*    
    async deleteBitacora (idBitacora) {
      try{
        await api.delete('/bitacoras/'+idBitacora)
          this.getDataPaginaDatos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },    
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
*/    
    fetchMedioComs() {
      fetch('http://localhost:8080/api/v1/vwmediocoms')
        .then(response => response.json())
        .then(data => {
          this.medioComs = data;
        })
        .catch(error => {
          console.error('Error fetching medioComs:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
